import React from 'react'

const Terms_Condition = () => {
  return (
    <div className='bg-white'>
      <div className="mt-5 space-y-0 ml-5 w-[95%] md:px-24 px-4 pt-5">
        <h1 className="md:text-[24px] text-[22px] mt-5 font-bold">TERMS & CONDITIONS</h1>

        <p className="inline md:text-[16px] font-bold text-[14px] text-[#979797] break-words whitespace-normal italic">
          Last updated on 22nd March 2025
        </p>
        <div className='md:h-10 h-5'></div>

        <div className="md:mt-10 mt-1 space-y-12">
          <p className="md:text-[32px] text-[16px] text-black font-medium">
            Welcome to FarmNet ("we", "us", or "our"). By accessing or using our website (the “Site”), you agree to be bound by these Terms and Conditions ("Terms"). If you do not agree with these Terms, please do not use the Site.
          </p>

          <div>
            <h2 className="md:text-[32px] text-[16px] font-bold">1. Acceptance of Terms</h2>
            <p className="md:text-[32px] text-[16px] text-black font-medium">
              By accessing or using FarmNet, you confirm that you are at least 18 years of age or have the permission of a parent or legal guardian, and that you agree to comply with and be bound by these Terms.
            </p>
          </div>

          <div>
            <h2 className="md:text-[32px] text-[16px] font-bold">2. Use of the Site</h2>
            <p className="md:text-[32px] text-[16px] text-black font-medium">
              You agree to use FarmNet for lawful purposes only. You may not:
              <br />• Use the Site in a way that violates any applicable laws or regulations.
              <br />• Transmit any viruses or malicious code.
              <br />• Attempt to gain unauthorized access to any part of the Site or its systems.
            </p>
          </div>

          <div>
            <h2 className="md:text-[32px] text-[16px] font-bold">3. Account Registration</h2>
            <p className="md:text-[32px] text-[16px] text-black font-medium">
              Some features of FarmNet may require you to register for an account. You agree to provide accurate and complete information and to keep your account credentials secure. You are responsible for all activities under your account.
            </p>
          </div>

          <div>
            <h2 className="md:text-[32px] text-[16px] font-bold">4. User Content</h2>
            <p className="md:text-[32px] text-[16px] text-black font-medium">
              If you post, upload, or submit any content to the Site, you grant FarmNet a non-exclusive, royalty-free, worldwide license to use, display, reproduce, and distribute such content in connection with the operation of the Site. You retain ownership of your content.
            </p>
          </div>

          <div>
            <h2 className="md:text-[32px] text-[16px] font-bold">5. Intellectual Property</h2>
            <p className="md:text-[32px] text-[16px] text-black font-medium">
              All content on FarmNet, including text, images, logos, and software, is the property of FarmNet or its licensors and is protected by intellectual property laws. You may not copy, reproduce, or distribute any part of the Site without prior written permission.
            </p>
          </div>

          <div>
            <h2 className="md:text-[32px] text-[16px] font-bold">6. Third-Party Links</h2>
            <p className="md:text-[32px] text-[16px] text-black font-medium">
              FarmNet may contain links to third-party websites. We are not responsible for the content or privacy practices of such websites and encourage you to review their terms and policies.
            </p>
          </div>

          <div>
            <h2 className="md:text-[32px] text-[16px] font-bold">7. Disclaimers</h2>
            <p className="md:text-[32px] text-[16px] text-black font-medium">
              FarmNet is provided "as is" and "as available" without warranties of any kind. We do not guarantee the accuracy, completeness, or reliability of any content or service on the Site.
            </p>
          </div>

          <div>
            <h2 className="md:text-[32px] text-[16px] font-bold">8. Limitation of Liability</h2>
            <p className="md:text-[32px] text-[16px] text-black font-medium">
              To the maximum extent permitted by law, FarmNet and its affiliates shall not be liable for any indirect, incidental, or consequential damages resulting from your use of the Site.
            </p>
          </div>

          <div>
            <h2 className="md:text-[32px] text-[16px] font-bold">9. Termination</h2>
            <p className="md:text-[32px] text-[16px] text-black font-medium">
              We reserve the right to suspend or terminate your access to FarmNet at any time, without notice or liability, for any reason including breach of these Terms.
            </p>
          </div>

          <div>
            <h2 className="md:text-[32px] text-[16px] font-bold">10. Changes to Terms</h2>
            <p className="md:text-[32px] text-[16px] text-black font-medium">
              We may update these Terms from time to time. Continued use of the Site after changes indicates your acceptance of the new Terms.
            </p>
          </div>

          <div>
            <h2 className="md:text-[32px] text-[16px] font-bold">11. Governing Law</h2>
            <p className="md:text-[32px] text-[16px] text-black font-medium">
              These Terms are governed by the laws of Namibia, without regard to its conflict of law provisions.
            </p>
          </div>

          <div>
            <h2 className="md:text-[32px] text-[16px] font-bold">12. Contact Us</h2>
            <p className="md:text-[32px] text-[16px] text-black font-medium mb-5">
              If you have any questions or concerns about these Terms, please contact us at: <br />
              Email: support@farmnet.com
            </p>
          </div>
          <div className='md:h-20 h-5'></div>
        </div>
      </div>
    </div>
  )
}

export default Terms_Condition
